// 第三方登录展示配置。授权地址和回调处理统一交给后端授权登录客户端。
const currentDomain = import.meta.client ? window.location.hostname : "";
const isLocalDomain =
	currentDomain === "localhost" ||
	currentDomain === "127.0.0.1" ||
	currentDomain === "::1" ||
	/^192\.168\./.test(currentDomain) ||
	/^10\./.test(currentDomain) ||
	/^172\.(1[6-9]|2\d|3[0-1])\./.test(currentDomain);

const canThirdDomain = [
	"localhost",
	"127.0.0.1",
	"::1",
	"10.1.20.43",
	"seerq.io",
	"www.seerq.io",
	"sandbox-gw.seeronnet.com",
	"sandbox-seer.seeronnet.com",
	"www.seeronnet.net",
	"www.seeronnet.com",
	"www.hspiritlink.com",
];

const isRegularDomainAllowed = currentDomain ? canThirdDomain.includes(currentDomain) : false;
const isDomainAllowed = isLocalDomain || isRegularDomainAllowed;

const allThirdLogins = [
	{
		name: "Google",
		icon: new URL("@/assets/images/login_ic_google.png", import.meta.url).href,
		type: "google",
		firebaseEvent: "site_login_google_click",
	},
	{
		name: "LINE",
		icon: new URL("@/assets/images/login_ic_line.png", import.meta.url).href,
		type: "line",
		firebaseEvent: "site_login_line_click",
	},
	{
		name: "Facebook",
		icon: new URL("@/assets/images/login_ic_facebook.png", import.meta.url).href,
		type: "facebook",
		firebaseEvent: "site_login_fb_click",
	},
];

const thirdLoginList = isDomainAllowed ? allThirdLogins : [];

export { thirdLoginList };
